import React, { createContext, useContext, useReducer } from "react";
import { initialState, repassesSetoriaisReducer, RepassesSetoriaisState } from "./repasses-setoriais-reducer";

type RepassesSetoriaisContextType = {
    state: RepassesSetoriaisState;
    dispatch: React.Dispatch<any>;
};

const RepassesSetoriaisContext = createContext<RepassesSetoriaisContextType | undefined>(undefined);

export const RepassesSetoriaisProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(repassesSetoriaisReducer, initialState);

    return (
        <RepassesSetoriaisContext.Provider value={{ state, dispatch }}>
            {children}
        </RepassesSetoriaisContext.Provider>
    );
};

export const useRepassesSetoriaisState = () => {
    const context = useContext(RepassesSetoriaisContext);
    if (!context) {
        throw new Error("useRepassesSetoriaisState must be used within RepassesSetoriaisProvider");
    }
    return context.state;
};

export const useRepassesSetoriaisDispatch = () => {
    const context = useContext(RepassesSetoriaisContext);
    if (!context) {
        throw new Error("useRepassesSetoriaisDispatch must be used within RepassesSetoriaisProvider");
    }
    return context.dispatch;
};
